import { Placement } from "./Placement";
import { BODY_SKINS, INVENTORY, PLACEMENT_TYPE_HERO } from "../helpers/consts";
import Sprite from "../components/object-graphics/Sprite";

export class FireTilePlacement extends Placement {
  damagesBodyOnCollide(forBody) {
    return (
      forBody.type === PLACEMENT_TYPE_HERO &&
      !this.level.inventory.has(INVENTORY.FIRE_PICKUP)
    );
  }

  changeHeroSkinOnCollide() {
    if (this.level.inventory.has(INVENTORY.FIRE_PICKUP)) {
      return BODY_SKINS.FIRE;
    }
    return BODY_SKINS.NORMAL;
  }

  renderComponent() {
    return <Sprite frameCoord={this.level.animatedTiles.fireFrame} />;
  }
}
